module.exports = __webpack_public_path__ + "17b7d08df4a955d7e4804c5ac36b1d7e.patt";